import { Route, Redirect } from "react-router-dom";
import { getValue } from "../auth";

function ProtectedRoute({ children, ...rest }: any) {
  let auth: boolean = Boolean(getValue("authStatus"));
  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default ProtectedRoute;
